import { useMemo } from 'react';

import { DEFAULT_PAGE_PREFIX_TITLE } from '@/constants/common';

export const usePageTitle = (title?: string, prefix: string = DEFAULT_PAGE_PREFIX_TITLE): string => {
  return useMemo(() => {
    return [prefix, title].filter(v => !!v).join(' | ');
  }, [prefix, title]);
};
